export enum BonusType {
    RegularBonus = "regular_bonus",
    AdvancePayment = "advance_payment",
}

export enum DeductionType {
    RegularDeduction = "regular_deduction",
    AdvanceRepayment = "advance_repayment",
}

export interface Bonus {
    type: BonusType;
    amount: number;
}

export interface Deduction {
    type: DeductionType;
    amount: number;
}
